import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function StazaPlaninarskaIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="StazaPlaninarskaIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="#FF0000" d="M3.5,88.387c-0.398,0-0.803-0.068-1.198-0.213c-1.816-0.662-2.751-2.671-2.089-4.487
	c5.52-15.14,20.316-44.163,36.81-45.644c4.357-0.39,10.666,1.06,16.001,10.191c2.542,4.352,6.88,9.316,13.099,8.255
	c9.288-1.585,21.221-16.455,26.942-46.102c0.366-1.898,2.203-3.142,4.1-2.773c1.898,0.366,3.14,2.202,2.773,4.1
	C94.262,41.121,81.756,60.922,67.299,63.39c-7.933,1.349-15.151-2.774-20.321-11.624c-4.212-7.211-8.064-6.866-9.331-6.75
	C27.503,45.926,13.73,67.042,6.788,86.085C6.271,87.505,4.929,88.387,3.5,88.387z"/>
    </svg>
  </SvgIcon>
}

export default StazaPlaninarskaIcon;
